document.addEventListener('DOMContentLoaded', function () {
	//Accordion JS
	var acc = document.getElementsByClassName("course-accordion");
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].onclick = function () {
			var panel = this.nextElementSibling;
			var coursePanel = document.getElementsByClassName("course-panel");
			var courseAccordion = document.getElementsByClassName("course-accordion");
			var courseAccordionActive = document.getElementsByClassName("course-accordion active");

			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
				this.classList.remove("active");
			} else {
				for (var ii = 0; ii < courseAccordionActive.length; ii++) {
					courseAccordionActive[ii].classList.remove("active");
				}
				for (var iii = 0; iii < coursePanel.length; iii++) {
					this.classList.remove("active");
					coursePanel[iii].style.maxHeight = null;
				}
				panel.style.maxHeight = panel.scrollHeight + "px";
				this.classList.add("active");
			}
		}
	}


// the below js is used to hide a class when close is clicked
	document.querySelector(".close_arrow").querySelector("button").addEventListener("click", closeFunction);

	function closeFunction() {
		document.body.classList.add('countdown-closed');
		document.documentElement.style.setProperty('--countdown-bar-height', `0px`);
		document.querySelector(".countdown-condensed").style.display = "none";
	}


// The below js is used to click humberger Menu
	if (document.querySelectorAll(".header_hamburger").length) {
		document.querySelectorAll(".header_hamburger").forEach(function (element) {
			element.addEventListener("click", addClass);
		});
	}

	function addClass() {
		document.body.classList.add('open-menu');
		let sidePanelelement = document.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist');
		sidePanelelement.forEach(function (ele) {
			if (sessionStorage.getItem("nav-title")) {
				let getTitle = sessionStorage.getItem("nav-title")
				if (ele.querySelector(`li [data-link="${getTitle}"]`)) {
					ele.querySelector(`li [data-link="${getTitle}"]`).click();
				}
				setTimeout(function () {
					sessionStorage.removeItem("nav-title");
				}, 800);
			} else {
				ele.querySelector('li button').click();
			}

			if (ele.querySelector('li [aria-current="page"]')) {
				ele.querySelector('li [aria-current="page"]').click();
			}

		});

		// Helper to position a single submenu
		function updateSubmenuPosition(Ele) {
			const nestedList = Ele.querySelector('.header-sidebar__nested-linklist');
			const detailsItem = Ele.querySelector('details');
			if (nestedList && detailsItem && detailsItem.hasAttribute('open')) {
				// requestAnimationFrame para asegurar que el panel ya este visible/layouteado
				// (con offsetTop directo, si el panel todavia esta con display:none por la
				// animacion de apertura, la medicion da 0 y queda mal posicionado)
				requestAnimationFrame(function () {
					const scroller = Ele.closest('.header-sidebar__scroller');
					if (!scroller) return;
					const scrollerRect = scroller.getBoundingClientRect();
					const parentTop = Ele.getBoundingClientRect().top - scrollerRect.top + scroller.scrollTop;
					const scrollerHeight = scroller.offsetHeight;
					const submenuHeight = nestedList.offsetHeight || 300;
					nestedList.style.bottom = 'auto';

					if (parentTop + submenuHeight > scrollerHeight) {
						let topPos = Math.max(0, scrollerHeight - submenuHeight - 20);
						nestedList.style.top = `${topPos}px`;
					} else {
						nestedList.style.top = `${parentTop}px`;
					}

					// Clear the min-height adjustment as we are using horizontal flyout
					scroller.style.minHeight = '';
				});
			}
		}

		// Initial initialization for any pre-opened items
		setTimeout(function() {
			if (document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel').length) {
				document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel .header-sidebar__linklist li').forEach(function(El) {
					if (El.querySelector('details') && El.querySelector('details').hasAttribute('open')) {
						updateSubmenuPosition(El);
					}
				});
			}
		}, 100);

		//On Hover Event For Sidebar Navigation
		if (document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel').length) {
			document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel').forEach(function (element) {
				element.querySelectorAll('.header-sidebar__linklist li').forEach(function (Element) {

					Element.addEventListener('mouseenter', function (Ele) {
						// First handle open state so we can calculate proper layout
						element.querySelectorAll('.header-sidebar__linklist li').forEach(function (El) {
							El.classList.remove('currentActive');
							if (El.querySelector('details')) {
								El.querySelector('details').removeAttribute('open');
							}
						})
						if (Ele.currentTarget.querySelector('details')) {
							Ele.currentTarget.classList.add('currentActive');
							Ele.currentTarget.querySelector('details').setAttribute('open', true);
						}

						// Now positioned correctly
						updateSubmenuPosition(Ele.currentTarget);
					})
				})
			});
		}

	}

//Slide Homepage slider on click Menu
	function findMainSliderByNavTitle(navTitle) {
		return Array.from(document.querySelectorAll('.main-slider')).find(function (slider) {
			return slider.dataset.navTitle === navTitle;
		});
	}

	function syncSidebarPanel(sidebar, navTitle) {
		if (!sidebar || !navTitle) return;

		let panelTrigger = Array.from(sidebar.querySelectorAll('.header-sidebar__main-panel [data-link][aria-controls]')).find(function (button) {
			return button.dataset.link === navTitle;
		});

		if (!panelTrigger) return;

		panelTrigger.click();
	}

	function openHeaderMenuForNavTitle(navTitle) {
		let sidebarId = window.matchMedia('(max-width: 999px)').matches ? 'sidebar-menu-mobile' : 'sidebar-menu';
		let sidebar = document.getElementById(sidebarId);
		if (!sidebar) return;

		let openButton = document.querySelector(`.header_hamburger[aria-controls="${sidebarId}"]`);

		if (sidebar.hasAttribute('open')) {
			syncSidebarPanel(sidebar, navTitle);
			return;
		}

		sidebar.addEventListener('dialog:after-show', function () {
			syncSidebarPanel(sidebar, navTitle);
		}, { once: true });

		if (openButton) {
			openButton.click();
		} else if (typeof sidebar.show === 'function') {
			document.body.classList.add('open-menu');
			sidebar.show();
		}
	}

	if (document.querySelector('.header__primary-nav')) {
		document.querySelectorAll('.header__primary-nav .header__primary-nav-item').forEach(function (ele) {
			ele.addEventListener('click', function (Element) {
				let getTitle = Element.currentTarget.getAttribute('data-title');
				let hasSliderNavigation = document.querySelector('.main-slider[data-nav-title]');
				let targetSlide = findMainSliderByNavTitle(getTitle);

				if (!getTitle || !hasSliderNavigation) return;

				Element.preventDefault();

				if (targetSlide) {
					let swiperMain = document.querySelector(".swiper_main");
					if (swiperMain && swiperMain.swiper) {
						swiperMain.swiper.slides.forEach((slide, index) => {
							let slideMainSlider = slide.querySelector('.main-slider');
							if (slideMainSlider && slideMainSlider.dataset.navTitle == getTitle) {
								swiperMain.swiper.slideTo(index);
							}
						});
					}
				}

				sessionStorage.setItem("nav-title", getTitle);
				openHeaderMenuForNavTitle(getTitle);
			})
		});
	}


//Drawer Close After Click on continue shopping Btn
	window.continueShopingBtn = function continueShopingBtn() {
		if (document.querySelectorAll('.js-continue-shoping').length) {
			document.querySelector("#cart-drawer").shadowRoot.querySelector("button").click();
		}
	}


// Clear All Filter Event In Drawer, excepto disponibilidad
window.facetClear = function facetClear() {
    if (document.querySelector('.js-facets-cart-clear')) {
        document.querySelector('.js-facets-cart-clear').addEventListener('click', function () {
            // Simular el clic para borrar todos los filtros
            if (document.querySelector(".collection__main")) {
                const clearAllButton = document.querySelector(".collection__main").querySelector('.active-facets .facets-clear-all');
                if (clearAllButton) {
                    clearAllButton.click(); // Borrar todos los filtros
                }

                // Mantener el filtro de disponibilidad activado
                const availabilityFilter = document.querySelector("input[name='filter.v.availability'][value='1']");
                if (availabilityFilter) {
                    availabilityFilter.checked = true; // Asegurarse de que el filtro de disponibilidad siga marcado
                }
            }

            // Crear una nueva URL con el filtro de disponibilidad
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            // Asegurarse de que el filtro de disponibilidad esté en la URL
            params.set('filter.v.availability', '1');

            // Actualizar la URL y recargar la página con el filtro de disponibilidad activo
            window.location.href = `${url.pathname}?${params.toString()}`;
        });
    }
};

window.facetClear();

//Shop The look click on dots On PdP
	if (document.querySelectorAll('shop-the-look-desktop-carousel .tap-area').length) {
		let dots = document.querySelectorAll('shop-the-look-desktop-carousel .tap-area');
		let prevButton = document.querySelector('.js-prev');
		let nextButton = document.querySelector('.js-next');
		let currentDotIndex = 0;
		prevButton.addEventListener('click', () => {
			if (currentDotIndex > 0) {
				if (nextButton.hasAttribute("disabled")) nextButton.removeAttribute("disabled");
				dots[currentDotIndex].setAttribute('aria-current', 'false');
				currentDotIndex--;
				dots[currentDotIndex].setAttribute('aria-current', 'true');
				dots[currentDotIndex].click();
			} else {
				prevButton.setAttribute('disabled', 'disabled');
			}
		});

		nextButton.addEventListener('click', () => {
			if (currentDotIndex < dots.length - 1) {
				if (prevButton.hasAttribute("disabled")) prevButton.removeAttribute("disabled");
				dots[currentDotIndex].setAttribute('aria-current', 'false');
				currentDotIndex++;
				dots[currentDotIndex].setAttribute('aria-current', 'true');
				dots[currentDotIndex].click();
			} else {
				nextButton.setAttribute('disabled', 'disabled');
			}
		});
	}

	var tabLinks = document.querySelectorAll(".js-faq-btn");
	var tabContent = document.querySelectorAll(".faq__category_title");

	tabLinks.forEach(function (el) {
		el.addEventListener("click", openTabs);
	});

	function openTabs(el) {
		var btnTarget = el.currentTarget;
		let getId = btnTarget.getAttribute('data-block-id');
		let click_heading = document.querySelector(`[id="${getId}"]`);
		tabContent.forEach(function (el) {
			el.classList.remove("tab-active");
		});

		tabLinks.forEach(function (el) {
			el.classList.remove("is-active");
		});

		click_heading.classList.add("tab-active");
		btnTarget.classList.add("is-active");
	}


//HIDE SHOW PASSWORD ON EYE CLICK
	if (document.querySelectorAll('.show_password').length && document.querySelectorAll('.hide_password').length) {
		document.querySelectorAll('.show_password').forEach(function (ele) {
			ele.addEventListener('click', function (element) {
				element.currentTarget.classList.add('hidden');
				element.currentTarget.closest('.form-control').querySelector('.hide_password').classList.remove('hidden');
				let password = element.currentTarget.closest('.form-control').querySelector(`input`),
					type = password.getAttribute("type") === "password" ? "text" : "password";
				password.setAttribute("type", type);
			});
		});

		document.querySelectorAll('.hide_password').forEach(function (ele) {
			ele.addEventListener('click', function (element) {
				element.currentTarget.classList.add('hidden')
				element.currentTarget.closest('.form-control').querySelector('.show_password').classList.remove('hidden');
				let password = element.currentTarget.closest('.form-control').querySelector(`input`),
					type = password.getAttribute("type") === "password" ? "text" : "password";
				password.setAttribute("type", type);
			});
		});
	}


//Contact page Validation JS
	let contactFormId = document.querySelector('#contact_form');
	if (contactFormId) {
		contactFormId.addEventListener('submit', function (event) {
			let setError = function (id, message) {
				let el = document.getElementById(id);
				if (el) el.innerText = message;
			};
			['nameError', 'emailError', 'conceptError', 'consultationError'].forEach(function (id) {
				setError(id, '');
			});

			let name = contactFormId.querySelector('[name="contact[name]"]').value.trim();
			let email = contactFormId.querySelector('[name="contact[email]"]').value.trim();
			let consultation = contactFormId.querySelector('[name="contact[body]"]').value.trim();
			let concept = contactFormId.querySelector('select[name^="contact["]');
			let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			let error = null;

			if (name === '') {
				error = ['nameError', 'se requiere nombre y apellido'];
			} else if (!emailRegex.test(email)) {
				error = ['emailError', 'Dirección de correo electrónico no válida'];
			} else if (concept && !concept.value) {
				error = ['conceptError', 'se requiere concepto'];
			} else if (consultation === '') {
				error = ['consultationError', 'Se requiere consulta'];
			}

			if (error) {
				event.preventDefault();
				setError(error[0], error[1]);
			}
		});
	}


//Foundation page Slider And Events
	if (document.querySelector('.year-slider')) {
		new Flickity(document.querySelector('.year-slider'), {
			cellAlign: "left",
			contain: true,
			wrapAround: false,
			prevNextButtons: true,
			pauseAutoPlayOnHover: false,
			pageDots: false,
			draggable: true
		});
	}

	let foundationYearWrap = document.querySelector('.foundation-main-wrap'),
		foundationContentWrap = document.querySelector('.js-foundation-content-wrap');
	if (foundationYearWrap) {
		foundationYearWrap.querySelectorAll('.js-timeline-date-btn').forEach(function (Element) {
			Element.addEventListener('click', function (ele) {
				foundationYearWrap.querySelectorAll('.js-timeline-date-btn').forEach(function (element) {
					element.classList.remove('is-active');
				});
				ele.currentTarget.classList.add('is-active');

				let getYear = ele.currentTarget.getAttribute('data-year');
				foundationContentWrap.querySelectorAll('.text-component').forEach(function (contentElement) {
					if (contentElement.getAttribute('data-year') === getYear) {
						contentElement.classList.remove('hidden');
					} else {
						contentElement.classList.add('hidden');
					}
				});
			});
		});
	}

	//Register Page Silbon People Checkbox
	let PeopleCheckobox = document.getElementById('customer_tags');
	if (PeopleCheckobox) {
		PeopleCheckobox.addEventListener('change', (event) => {
			if (event.currentTarget.checked) {
				event.currentTarget.value = "SilbonPeople";
			} else {
				event.currentTarget.value = '';
			}
		});
	}


	
	
	


// side bar menu dragable //
	let mouseDown = false;
	let startX, scrollLeft;
	const slider = document.querySelector('.header-sidebar__scroller');

	const startDragging = (e) => {
		mouseDown = true;
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	}

	const stopDragging = (e) => {
		mouseDown = false;
	}

	const move = (e) => {
		e.preventDefault();
		if (!mouseDown) {
			return;
		}
		const x = e.pageX - slider.offsetLeft;
		const scroll = x - startX;
		slider.scrollLeft = scrollLeft - scroll;
	}

// Add the event listeners
	slider.addEventListener('mousemove', move, false);
	slider.addEventListener('mousedown', startDragging, false);
	slider.addEventListener('mouseup', stopDragging, false);
	slider.addEventListener('mouseleave', stopDragging, false);
});
const openDrawerBtn = document.getElementById('openDrawerBtn');
document.addEventListener('DOMContentLoaded', function () {
	const openDrawerBtn = document.getElementById('openDrawerBtn');
	const closeDrawerBtn = document.getElementById('closeDrawerBtn');
	const drawer = document.getElementById('drawer');
	const overlay = document.getElementById('overlay');

	if (openDrawerBtn) {
		openDrawerBtn.addEventListener('click', () => {
			drawer.classList.add('opened');
			overlay.classList.add('opened');
			document.body.classList.add('drawer-opened'); // Add class to body
		});
	}

	if (closeDrawerBtn) {
		closeDrawerBtn.addEventListener('click', () => {
			closeDrawer();
		});
	}

	if (overlay) {
		overlay.addEventListener('click', () => {
			closeDrawer();
		});
	}

	function closeDrawer() {
		drawer.classList.remove('opened');
		overlay.classList.remove('opened');
		document.body.classList.remove('drawer-opened'); // Remove class from body
	}

	function toggleDrawer() {
		var body = document.querySelector("body");
		var overlay = document.getElementById("drawer_customer_registrate_main_overlay");
		var hasClass = body.classList.contains("drawer_customer_registrate_main");

		if (!hasClass) {
			body.classList.add("drawer_customer_registrate_main"); // Add the specified class to body
		} else {
			body.classList.remove("drawer_customer_registrate_main"); // Remove the specified class from body
		}
	}

	window.addEventListener('scroll', function () {
		let stickyHeaderOffset = parseFloat(document.querySelector('html').style.getPropertyValue('--header-height'));

		let checkElementInView = function (element) {
			if (element) {
				let elementOffsetTop = parseFloat(element.offsetTop),
					elementHeight = parseFloat(element.offsetHeight),
					windowHeight = window.innerHeight,
					scrollTop = window.scrollY;

				return scrollTop + windowHeight > elementOffsetTop && scrollTop < elementOffsetTop + elementHeight;
			}
			return false;
		};

		let newsletterElement = document.querySelector('.shopify-section-group-footer-group');
		let iconWithHorizontalElement = document.querySelector('.icon_with_horizontal');
		let footerElement = document.querySelector('.footer');

		let isNewsletterInView = checkElementInView(newsletterElement);
		let isIconWithHorizontalInView = checkElementInView(iconWithHorizontalElement);
		let isFooterInView = checkElementInView(footerElement);

		// if (isNewsletterInView || isIconWithHorizontalInView || isFooterInView) {
		// 	document.body.classList.add('header_not_sticky');
		// } else {
		// 	document.body.classList.remove('header_not_sticky');
		// }
	});

	document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
	if (Shopify.designMode) {
		document.documentElement.classList.add('shopify-design-mode');
	}
	document.documentElement.style.setProperty('--viewport-height', window.visualViewport.height + 'px');
	document.documentElement.style.setProperty('--viewport-width', window.visualViewport.width + 'px');

	var initialWidth = window.visualViewport.width;
	window.addEventListener('resize', function () {
		var newWidth = window.visualViewport.width;
		if (newWidth !== initialWidth) {
			document.documentElement.style.setProperty('--viewport-height', window.visualViewport.height + 'px');
			document.documentElement.style.setProperty('--viewport-width', window.visualViewport.width + 'px');
		}
	});

	function getBroswerDetails() {
		//Checking the user's OS and Browser
		if ((navigator.userAgent).includes("Android")) {
			document.querySelector("html").classList.add("android");
		} else if ((navigator.userAgent).includes("Mac")) {
			document.querySelector("html").classList.add("mac");
		} else {
			document.querySelector("html").classList.add("windows");
		}


		//-- Browser --//
		var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		var isFirefox = typeof InstallTrigger !== 'undefined';
		var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		})(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
		var isIE = /*@cc_on!@*/ false || !!document.documentMode;
		var isEdge = !isIE && !!window.StyleMedia;
		var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
		var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
		var isBlink = (isChrome || isOpera) && !!window.CSS;
		if (isFirefox) {
			document.querySelector("html").classList.add("isFirefox")
		} else if (isChrome) {
			document.querySelector("html").classList.add("isChrome")
		} else if (isSafari) {
			document.querySelector("html").classList.add("isSafari")
		} else if (isOpera) {
			document.querySelector("html").classList.add("isOpera")
		} else if (isIE) {
			document.querySelector("html").classList.add("isIE")
		} else if (isEdge) {
			document.querySelector("html").classList.add("isEdge")
		} else if (isEdgeChromium) {
			document.querySelector("html").classList.add("isEdgeChromium")
		} else {
			document.querySelector("html").classList.add("isBlink")
		}
	}

	getBroswerDetails();

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		// true for mobile device
		document.querySelector("html").classList.add("mobile");
	}
});

// ─── Validacion de RUT en la pagina /cart ───────────────────────────────
// Mientras el RUT no sea valido, el boton de "ir a pagar" de la pagina del
// carrito (main-cart.liquid) queda deshabilitado. Se valida con el
// algoritmo oficial chileno (modulo 11) y se guarda como atributo del cart
// para que quede en el pedido.
//
// El cart drawer y la ventanita de "producto anadido" ya NO van directo al
// checkout: su boton ahora es un link a /cart, que es donde se pide el RUT.
//
// Usa delegacion de eventos sobre el form (no engancha el input una sola
// vez) por si el tema llega a re-renderizar el contenido al cambiar
// cantidades - asi el input y el boton siguen funcionando igual.
document.addEventListener('DOMContentLoaded', function () {
	var cartForm = document.getElementById('cart-page-form');
	if (!cartForm) return;

	var rutUtils = {
		normalize: function (raw) {
			return (raw || '').trim().replace(/\./g, '').replace(/[‐–—]/g, '-').toLowerCase();
		},
		computeDV: function (rutNumber) {
			var T = parseInt(rutNumber, 10), M = 0, S = 1;
			for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
			return S ? String(S - 1) : 'k';
		},
		isValidRut: function (rutCompleto) {
			var v = this.normalize(rutCompleto);
			if (!/^\d{7,8}-[\dk]$/.test(v)) return false;
			var parts = v.split('-');
			return this.computeDV(parts[0]) === parts[1];
		}
	};

	var EXTRANJERO_RUT = '55555555-5';

	function validateRUT(value) {
		var v = (value || '').trim();
		if (!v) return { ok: false, msg: 'Campo obligatorio' };
		if (v.indexOf('.') !== -1) return { ok: false, msg: 'Sin puntos (ej: 12345678-5)' };
		if (!rutUtils.isValidRut(v)) return { ok: false, msg: 'RUT invalido. Ej: 12345678-5' };
		return { ok: true };
	}

	function applyCheckoutState(enabled) {
		cartForm.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
			btn.toggleAttribute('disabled', !enabled);
			btn.classList.toggle('is-disabled', !enabled);
			if (!enabled) btn.setAttribute('title', 'Completa el RUT para continuar');
			else btn.removeAttribute('title');
		});
	}

	function runValidation(showErrors) {
		var input = cartForm.querySelector('#CartRUT');
		if (!input) {
			applyCheckoutState(true);
			return true;
		}

		var field = cartForm.querySelector('#cart-rut-field');
		var error = cartForm.querySelector('#CartRUTError');
		var r = validateRUT(input.value);

		if (field && error) {
			if (!r.ok && showErrors) {
				field.classList.add('-has-error');
				error.textContent = r.msg;
			} else {
				field.classList.remove('-has-error');
				error.textContent = '';
			}
		}

		applyCheckoutState(r.ok);
		return r.ok;
	}

	var saveTimer;
	function saveAttribute() {
		var input = cartForm.querySelector('#CartRUT');
		if (!input) return;
		return fetch('/cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ attributes: { RUT: (input.value || '').trim() } })
		}).catch(function () {});
	}
	function scheduleSave() {
		clearTimeout(saveTimer);
		saveTimer = setTimeout(saveAttribute, 300);
	}

	cartForm.addEventListener('keydown', function (e) {
		if (e.target && e.target.id === 'CartRUT' && e.key === ' ' && e.target.selectionStart === 0) {
			e.preventDefault();
		}
	});

	// Evita que el tema confunda el tipeo del RUT con un cambio de cantidad
	cartForm.addEventListener('input', function (e) {
		if (!e.target || e.target.id !== 'CartRUT') return;
		e.stopPropagation();
		e.target.value = e.target.value.replace(/^\s+/, '');
		runValidation(false);
		scheduleSave();
	}, true);

	cartForm.addEventListener('blur', function (e) {
		if (!e.target || e.target.id !== 'CartRUT') return;
		runValidation(true);
		saveAttribute();
	}, true);

	cartForm.addEventListener('click', function (e) {
		var btn = e.target.closest && e.target.closest('button[name="checkout"]');
		if (!btn) return;
		if (!runValidation(true)) {
			e.preventDefault();
			e.stopPropagation();
			var input = cartForm.querySelector('#CartRUT');
			if (input) input.focus();
			return;
		}
		saveAttribute();
	}, true);

	// ─── Checkbox "Soy extranjero, no cuento con RUT" ───────────────────
	// Al marcarlo, el input de RUT se autocompleta con un RUT generico y
	// queda de solo lectura (pero sigue viajando en el POST del form).
	// Al desmarcarlo, se vacia y vuelve a ser editable.
	function setExtranjeroState(checked, focusInput) {
		var input = cartForm.querySelector('#CartRUT');
		if (!input) return;
		if (checked) {
			input.value = EXTRANJERO_RUT;
			input.readOnly = true;
		} else {
			input.value = '';
			input.readOnly = false;
			if (focusInput) input.focus();
		}
		runValidation(false);
	}

	cartForm.addEventListener('change', function (e) {
		if (!e.target || e.target.id !== 'cb-rut-extranjero') return;
		setExtranjeroState(e.target.checked, true);
		saveAttribute();
	});

	var extranjeroCheckbox = cartForm.querySelector('#cb-rut-extranjero');
	if (extranjeroCheckbox && extranjeroCheckbox.checked) {
		setExtranjeroState(true, false);
	}

	runValidation(false);
});
